import AccommodationIndividualSelectRoomTile from 'components/AccommodationKit/AccommodationIndividualSelectRoom/AccommodationIndividualSelectRoomTile'
import AccommodationIndividualSelectRoomTileDetails from 'components/AccommodationKit/AccommodationIndividualSelectRoom/AccommodationIndividualSelectRoomTileDetails'
import AccommodationRoomTileImage from 'components/AccommodationKit/AccommodationRoomTileImage'
import CardCarousel from 'LuxKit/Carousel/CardCarousel'
import React, { useMemo } from 'react'
import type { OfferPageRoom } from 'contexts/OfferPage/offerPageStateReducer'
import { rem } from 'polished'
import AccommodationIndividualSelectRoomOptions from 'components/AccommodationKit/AccommodationIndividualSelectRoom/AccommodationIndividualSelectRoomOptions'
import IndividualRoomSelectRoomOption from './IndividualRoomSelectRoomOption'
import useToggle from 'hooks/useToggle'

interface Props {
  optionVariant: 'stacked' | 'carousel'
  currentRoom: OfferPageRoom
  packageViewOptions: Array<App.OfferPackageOptionView>
  onSelect: (packageOption: App.HotelPackage) => void
  suggestedPackageOption?: {
    option: App.OfferPackageOptionView
    message: string
  }
}

function IndividualRoomSelectRoom({
  optionVariant,
  currentRoom,
  packageViewOptions,
  onSelect,
  suggestedPackageOption,
}: Props) {
  const currentlySelectedOption = useMemo(() => (
    packageViewOptions.find(option => option.package.id === currentRoom.roomId && option.package.roomRate.id === currentRoom.rateId)
  ), [currentRoom, packageViewOptions])

  const carouselWidth = packageViewOptions.length > 1 ? rem(300) : '100%'

  const { value: inclusionsOpen, toggle: onInclusionsToggle } = useToggle()

  return <AccommodationIndividualSelectRoomTile roomPackage={packageViewOptions[0].package} isCurrentSelection={packageViewOptions[0].package.id === currentRoom.roomId}>
    <AccommodationRoomTileImage
      roomPackage={packageViewOptions[0].package}
      showBookmark={false}
    />
    <AccommodationIndividualSelectRoomTileDetails
      roomPackage={packageViewOptions[0].package}
    />
    <AccommodationIndividualSelectRoomOptions hasOptions>
      {optionVariant === 'carousel' &&
        <CardCarousel width={carouselWidth} gutterSize={20} gap={12} snap="start">
          {packageViewOptions.map((packageView, index) => <IndividualRoomSelectRoomOption
            key={packageView.package.uniqueKey}
            packageNumber={index + 1}
            packageView={packageView}
            currentRoom={currentRoom}
            onOptionSelect={onSelect}
            currentlySelectedOption={currentlySelectedOption}
            variant="carousel"
            suggestedPackageMessage={suggestedPackageOption?.option.package.uniqueKey === packageView.package.uniqueKey ? suggestedPackageOption.message : undefined}
            inclusionsOpen={inclusionsOpen}
            onInclusionsToggle={onInclusionsToggle}
          />)}
        </CardCarousel>}
      {optionVariant === 'stacked' && packageViewOptions.map((packageView, index) => <IndividualRoomSelectRoomOption
        key={packageView.package.uniqueKey}
        packageNumber={index + 1}
        packageView={packageView}
        currentRoom={currentRoom}
        onOptionSelect={onSelect}
        currentlySelectedOption={currentlySelectedOption}
        variant="stacked"
        suggestedPackageMessage={suggestedPackageOption?.option.package.uniqueKey === packageView.package.uniqueKey ? suggestedPackageOption.message : undefined}
      />)}
    </AccommodationIndividualSelectRoomOptions>
  </AccommodationIndividualSelectRoomTile>
}

export default IndividualRoomSelectRoom
